/* @flow */
import workflow from './workflow';
import { open } from 'ducks/workflow';
import OpenButton from 'components/buttons/workflow/OpenButton';

export default workflow({action: open})(OpenButton);
